<template>
  <div class="search">
    <input
      type="text"
      placeholder=" Search for movies or tv shows"
      class="search--input"
      v-model="search"
      @keyup.enter="fetchSearch"
    />
    <font-awesome-icon class="search--icon" icon="search" />
    <font-awesome-icon
      v-show="search"
      class="search--icon-right"
      icon="times"
      @click="resetCriteria()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    delayTimer: "",
    search: ""
  }),
  computed: mapState(["generalCriteria"]),
  mounted() {
    this.search = this.generalCriteria;
  },
  watch: {
    search() {
      if (this.$route.name == "Home") {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.$store.dispatch("FETCH_EDIT_CRITERIA", this.search);
        }, 2000);
      }
    }
  },
  methods: {
    fetchSearch() {
      clearTimeout(this.delayTimer);
      this.$store.dispatch("FETCH_EDIT_CRITERIA", this.search);
      if (this.$route.path != "/") this.$router.push("/");
    },
    resetCriteria() {
      this.search = "";
      this.$store.dispatch("FETCH_EDIT_CRITERIA", "");
    }
  }
};
</script>

<style scoped>
.search {
  padding: 0 2%;
  position: relative;
  width: 96%;
}
.search--input {
  width: 100%;
  margin: 0;
  background-color: #707070;
  padding: 7px 7% 6px 40px;
  border-radius: 15px;
  border: 0px;
  box-sizing: border-box;
}
.search--input::placeholder {
  padding-left: 0%;
}

.search--icon {
  color: rgba(255, 255, 255, 0.56);
  position: absolute;
  left: 25px;
  top: 7px;
  z-index: 1000;
}
.search--icon-right {
  color: rgba(255, 255, 255, 0.56);
  position: absolute;
  right: 5%;
  top: 7px;
  z-index: 1000;
  padding-left: 29px;
  cursor: pointer;
}

@media (min-width: 1264px) and (max-width: 1904px) {
  .search--icon {
    left: 25px;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .search--icon {
    left: 22px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .search--icon {
    left: 18px;
  }
  .search--input {
    padding-left: 32px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .search--icon {
    left: 18px;
  }
  .search--input {
    padding-left: 32px;
  }
}

@media (max-width: 600px) {
  .search--icon {
    left: 15px;
  }
  .search--input {
    padding-left: 32px;
  }
}
</style>
<style scoped>
input {
  color: rgba(255, 255, 255, 0.86);
}

input::placeholder {
  color: rgba(255, 255, 255, 0.56);
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}
</style>
